export default class QAScorecardFilterViewModel {
    isActive: boolean = false;
    scorecardType: string = 'All';
    showInactiveScorecards: boolean = false;
    templateId: number = 0;
    templateName: string = '';
}
